export default __webpack_public_path__ + "static/media/checkboxBlue.ad8c65a3.svg";